<template>
    <color-options-wrapper :xAxisScroll="xAxisScroll">
        <button
            v-for="colorway in availableColorways" :key="colorway.option.code"
            :class="[
                'cz2__color-option my-2',
                {
                    'border-black border-2 bg-white': colorway.selected,
                    'cz2__color-option--border': colorway.custom && colorway.custom['v-border'] === 'true',
                    'option-unavailable': colorway.ats == null || colorway.ats === 0,
                }
            ]"
            @click.prevent="selectColorway(colorway)"
            :aria-label="colorway.name">
            <span class="cz2__color-option__color border border-gray-500 rounded-full" :style="colorway.style" />
            <div
                class="h-[50px] w-[50px] absolute top-0 left-0"
                :class="colorway.ats == null || colorway.ats === 0 ? '' : 'hover:-top-[2px] hover:-left-[2px]'"
                v-if="colorway.ats == null || colorway.ats === 0">
                <div class="bg-gray-400 h-[50px] w-[50px] absolute left-0 top-0 bg-opacity-60 rounded-full rotate-45" />
                <div class="w-[50px] h-[4px] bg-gray-600 absolute left-0 top-[23px] rotate-45"></div>
            </div>
            <span class="cz2__color-option__name w-32" v-if="colorway.ats && colorway.ats !== 0">
                {{ colorway.name }}
            </span>
        </button>
        <div class="cz2__color-filler"></div>
    </color-options-wrapper>
</template>

<script>
    import ColorOptionsWrapper from './ColorOptionsWrapper.vue';

    export default {
        props: {
            availableColorways: {
                type: Array,
                required: true,
            },
            xAxisScroll: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            selectColorway(color) {
                this.$emit('selectColorway', color);
            },
        },
        components: { ColorOptionsWrapper },
    };
</script>

<style lang="scss">
@import "../../style/variables.scss";

.cz2__colors__options {
    @media (hover: hover) {
        &:hover {
            .cz2__color-option:focus {
                .cz2__color-option__name {
                    visibility: hidden;
                    opacity: 0;
                }

                &:hover {
                    .cz2__color-option__name {
                        visibility: visible;
                        opacity: 1;
                    }
                }
            }
        }
    }
}

.cz2__color-option {
    position: relative;

    margin-left: 3px;
    margin-right: 3px;

    width: 50px;
    height: 50px;

    border-radius: 40px;

    &.cz2__color-option--border {
        .cz2__color-option__color {
            box-shadow: 0 0 1px rgba(0, 0, 0, 0.5) inset;
        }
    }

    @media (hover: hover) {
        &:focus {
            background: #fff;
            border: 2px solid #000;
            .cz2__color-option__name {
                visibility: visible;
                opacity: 1;
            }
        }

        &:hover {
            background: #fff;
            border: 2px solid #b1b3b3;
            .cz2__color-option__name {
                visibility: visible;

                opacity: 1;
            }
        }
    }
}

.cz2__color-option__color {
    display: block;
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 30px;
    left: calc(50% - 20px);
    top: calc(50% - 20px);
    overflow: hidden;
    background-size: cover;
}

.cz2__color-option__name {
    position: absolute;
    display: block;

    visibility: hidden;
    opacity: 0;

    z-index: 1;

    transition: opacity $transition-fast ease-out;

    left: 50%;
    top: 38px;

    transform: translate(-50%, 0);

    padding: 6px 13px;

    color: #000000;
    font-family: $font-main;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;

    background: #fff;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);

    @include respond-below(sm) {
        display: none;
    }

    &:before {
        content: "";

        position: absolute;

        left: calc(50% - 6px);

        top: -7px;
        width: 14px;
        height: 14px;

        background: #fff;

        transform: rotate(45deg);

        box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
    }

    &:after {
        content: "";

        position: absolute;

        left: calc(50% - 12px);
        top: 0px;

        width: 24px;
        height: 10px;

        background: #fff;
    }
}
</style>
